import React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface INoSelectedInvoicesWarningDialogProps {
    dialogName: string;
    hideDialog: () => void;
    label?: string;
    heading?: string;
}

const NoSelectedInvoicesWarningDialog = (props: INoSelectedInvoicesWarningDialogProps) => {

    return (
        <Dialog title={props?.heading ? props?.heading : ''} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '15%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    ⚠️
                    <label>{!!props?.label ? props?.label : ``}</label>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Close'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default NoSelectedInvoicesWarningDialog;


// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/NoSelectedInvoicesWarningDialog.tsx